import * as React from 'react';
import { DataGrid, GridSelectionModel } from '@material-ui/data-grid';
import { API } from 'aws-amplify';
import { getAPIName } from '../config';
import handleApiErrors from '../common/handleApiErrors';
import { useSnackbar } from 'notistack';
import Contract from "../_models/Contract"

interface contract extends Contract {
  dealershipid : number;
}

export default function ServerPaginationGridRONumber(props: any) {
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);
  const [rows, setRows] = React.useState<contract[]>([]);
  const [loading, setLoading] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const loadServerRows = async (
    page: number,
    pageSize: number,
    searchterm: string
  ) => {
    const queries: Array<{ name: string; value: string }> = [];
    queries.push({ name: 'limit', value: `${pageSize}` });
    queries.push({
      name: 'offset',
      value: `${pageSize * page - pageSize}`,
    });

    if (searchterm !== '')
      queries.push({
        name: 'search-term',
        value: `${searchterm}`,
      });

    let path: string = '/contracts';
    if (queries.length >= 1) {
      const paramStrings: string[] = queries.map(
        (q) => `${encodeURIComponent(q.name)}=${encodeURIComponent(q.value)}`
      );
      path = `${path}?${paramStrings.join('&')}`;
    }

    try {
      if (searchterm !== '') {
        let results = await API.get(getAPIName(), path, {});
        return {
          body: results.body,
          totalRecords: results.totalRecordCount,
        };
      }
      return { body: [], totalRecords: 0 };
    } catch (e) {
      handleApiErrors(e, enqueueSnackbar);
      return { body: [], totalRecords: 0 };
    }
  };

  const handlePageChange = (params: any) => {
    setPage(params.page);
  };

  React.useEffect(() => {
    let active = true;

    (async () => {
      setLoading(true);
      const newRows: any = await loadServerRows(
        page,
        pageSize,
        props.searchTerm
      );

      if (!active) {
        return;
      }
      setRows(newRows.body);
      setRowCount(newRows.totalRecords);
      setLoading(false);
    })();

    return () => {
      active = false;
    };
  }, [page, props.searchTerm]);

  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={[
          {
            field: 'contractnumber',
            headerName: 'Contract #',
            width: 200,
          },
          { field: 'dealershipid', headerName: 'Dealership Id', width: 150 },
          { field: 'ro_number', headerName: 'RO Number', width: 150 },
          { field: 'dateout', headerName: 'Date Out', width: 200 },
        ]}
        pagination
        pageSize={pageSize}
        rowCount={rowCount}
        paginationMode="server"
        onPageChange={handlePageChange}
        onSelectionModelChange={(selection: GridSelectionModel) => {
          const selectedRowId = selection[0];
          const foundRow = rows?.find((row: any) => row.id === selectedRowId);
          if (foundRow) {
            props.handleChange({
              'dealershipid': foundRow.dealershipid,
              'contractid': foundRow.id,
              "firstName": foundRow.customer.firstname,
              "lastName": foundRow.customer.lastname,
              "email": foundRow.customer.emailaddress,
              "roNumber": foundRow.ro_number,
              "serviceAdvisorId": foundRow.service_advisor_id,
              "dateIn": foundRow.datein,
              "dateOut": foundRow.dateout,
              "contractnumber": foundRow.contractnumber,
              "licenseplate" : foundRow.vehicle.licenseplate,
              "state" : foundRow.vehicle.state,
            });
          }
        }}
        loading={loading}
      />
    </div>
  );
}
